export enum FormInstanceDataTypeEnum
{
    Double = 0,
    String = 1,
    Boolean = 2,
    Date = 3,
    Array = 4,
    Grid = 5
}
